export enum OrientationBreakpoints {
	Landscape = "(orientation: landscape)",
	Portrait = "(orientation: portrait)",
}
